"use client";

import type { HTMLAttributes } from "react";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import Box from "@/shared/components/common/Box";
import type { ReactNode } from "react";
import PhosphorIcon, {
  type PhosphorIconName,
} from "@/shared/components/common/PhosphorIcon";

interface DetailCardProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  icon: PhosphorIconName;
  children: ReactNode;
}

export default function DetailCard({
  title,
  icon,
  children,
  ...props
}: DetailCardProps) {
  return (
    <Box className="mt-7 z-0!" {...props}>
      <Flex className="gap-x-2 items-center py-4 max-md:pt-5 max-md:pb-2">
        <PhosphorIcon
          name={icon}
          size={22}
          className="text-muted-foreground dark:text-muted"
          weight="fill"
        />
        <Typography
          variant="h2"
          className="text-xl font-semibold max-md:text-lg"
        >
          {title}
        </Typography>
      </Flex>
      {children}
    </Box>
  );
}
